const parseDay = (value) => {
  const [y, m, d] = String(value || "").split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export function formatLongDate(value) {
  const day = parseDay(value);
  return day ? day.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";
}

export function formatDayLabel(value) {
  const day = parseDay(value);
  return day ? day.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }) : "";
}

export function formatClock(value) {
  const [h, m] = String(value || "").split(":").map((n) => parseInt(n, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return "";
  const period = h < 12 ? "AM" : "PM";
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${String(m).padStart(2, "0")} ${period}`;
}

export function formatClockRange(start, end) {
  if (!start) return "";
  if (!end) return formatClock(start);
  const [startClock, startPeriod] = formatClock(start).split(" ");
  const endText = formatClock(end);
  return startPeriod === endText.split(" ")[1] ? `${startClock} – ${endText}` : `${formatClock(start)} – ${endText}`;
}
